import React from 'react';
import { useAppSelector } from './store/hooks';
import { ConnectionState } from './services/DBService/DbService';
import Login from './views/Login';
import './css/App.css';
import Router from './Router';
import { initBeforeLogin } from './services/InitService/InitService';
import { hasConnectionForLogin } from './services/CordovaService/NetworkConnectionService';
import TopBar from './components/molecules/TopBar';
import PrimaryButton from './components/atoms/PrimaryButton';
import LoadingScreen from './components/atoms/LoadingScreen';
import { APP_NAME } from './constants';
import { getLoginFailureMessage } from './services/LoginErrorMessageService';

export default function App() {
    const connectionState = useAppSelector(state => state.globalState.connectionState);
    const dbFatalErrorCode = useAppSelector(state => state.globalState.dbFatalErrorCode);
    const dbFatalErrorHttpStatus = useAppSelector(state => state.globalState.dbFatalErrorHttpStatus);

    React.useEffect(() => {
        initBeforeLogin();
    }, []);

    let content: JSX.Element;
    switch (connectionState) {
        case ConnectionState.DISCONNECTED:
            content = <Login />;
            break;
        case ConnectionState.CONNECTING:
            content = <LoadingScreen message="verbinden..."/>;
            break;
        case ConnectionState.SYNCHRONIZING:
            content = <LoadingScreen message="synchronisieren..." />;
            break;
        case ConnectionState.CONNECTION_FAILED:
            content = <Login error={
                dbFatalErrorCode
                    ? getLoginFailureMessage(dbFatalErrorCode, dbFatalErrorHttpStatus)
                    : 'Verbindung fehlgeschlagen. Bitte erneut versuchen.'
            } />;
            break;
        case ConnectionState.PASSWORD_CHANGED:
            content = <Login error="Passwort wurde geändert. Bitte das neue Passwort eingeben." />;
            break;
        case ConnectionState.CONNECTION_ESTABLISHED:
            return <div className="react-root">
                <Router />
            </div>;
            break;
        default:
            content = <div>Unbekannter Verbindungsstatus</div>;
            break;
    }

    let renderContent = content;
    if (!hasConnectionForLogin()) {
        renderContent = <div>
            <div>Offline! Für die Anmeldung wird eine Internetverbindung benötigt.</div>
            <PrimaryButton
                label="Erneut versuchen"
                onClick={() => location.reload()}
            />
        </div>;
    }

    return (
        <div className="react-root">
            <div className="login-container">
                <TopBar title={APP_NAME} />
                {renderContent}
            </div>
        </div>
    );
}